import type { AccountTransaction } from '@mls-wallet/shared-types';

/** Poll exactly the separately signed children returned by a batch action. */
export function toPendingTransactionSignables(
  transactions: AccountTransaction[]
) {
  return transactions.flatMap((transaction) =>
    transaction.children.map((child) => ({
      id: child.id,
      approvals: child.approvals,
      rejections: child.rejections,
      requiredApprovals: child.policy.requiredApprovals,
      initiatorSignature: child.initiatorSignature,
    }))
  );
}
